<div class="grid ">
	<div class="col-12">
		<div class="card">
			<h4>Novo Menu</h4>
			<form (keypress)="ocultarMensagem()" (ngSubmit)="f.form.valid && salvar()" #f="ngForm" name="form"
				novalidate>
				<div class="formgroup">
					<div class="p-fluid p-formgrid grid">
						<div class="field col-12 md:col-12">
							<p-divider></p-divider>
						</div>
						<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
							<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
						</div>

						<div class="field col-12 md:col-6">
							<label htmlFor="descricao">Descrição</label>
							<input type="text" pInputText
								placeholder="Insira a descrição do Menu" name="descricao" ngModel #descricao="ngModel"
								required />
							<div *ngIf="descricao.hasError('required') && descricao.touched" class="alerta">
								<small>Campo obrigatório</small>
							</div>
						</div>

						<div class="field col-12 md:col-6">
							<label htmlFor="url">URL</label>
							<input type="text" pInputText
								placeholder="Insira a URL" name="url" ngModel #url="ngModel"/>
						</div>

						<div class="field col-12 md:col-6">
							<label htmlFor="icon">Ícone</label>
							<input type="text" pInputText
								placeholder="Insira o ícone" name="icon" ngModel #icon="ngModel"
								required />
							<div *ngIf="icon.hasError('required') && icon.touched" class="alerta">
								<small>Campo obrigatório</small>
							</div>
						</div>

						<div class="field col-12 md:col-6">
							<label htmlFor="posicaoExibicao">Posição de Exibição</label>
							<input type="number" pInputText name="posicaoExibicao" ngModel #posicaoExibicao="ngModel"
								required />
							<div *ngIf="posicaoExibicao.hasError('required') && posicaoExibicao.touched" class="alerta">
								<small>Campo obrigatório</small>
							</div>
						</div>

						<div class="field col-12 md:col-6">
							<label htmlFor="menuId">Menu</label>
							<p-dropdown [options]="menus" optionLabel="descricao" optionValue="id"  placeholder="Selecione"
							[filter]="true"   emptyFilterMessage="Nenhum registro"
							name="menuId" ngModel #menuId="ngModel" ></p-dropdown>
						</div>
						<div class="field col-12 md:col-6">
							<label htmlFor="permissao">Permissão</label>
							<p-dropdown [options]="permissoes" optionLabel="label" optionValue="value" placeholder="Selecione"
							[filter]="true"   emptyFilterMessage="Nenhum registro"
							name="permissao" ngModel #permissao="ngModel" [required]="true"></p-dropdown>
							<div *ngIf="permissao.hasError('required') && permissao.touched" class="alerta">
								<small>Campo obrigatório</small>
							</div>
						</div>
						<div class="field col-12 md:col-2">
							<label htmlFor="exclusivoRfarias">Exclusivo Rfarias</label>
							<br/>
							<p-inputSwitch  name="exclusivoRfarias" ngModel #exclusivoRfarias="ngModel" [(ngModel)]="valorExclusivoRfarias"></p-inputSwitch>
						</div>

					</div>
					<div class="p-fluid p-formgrid grid">
						<div class="field col-12 md:col-2" *ngIf="!progressoRequisicao">
							<button type="submit" pButton icon="pi pi-check" label="Salvar"
								class="p-button-success mt-5" [disabled]="!f.valid"></button>
						</div>
						<div class="field col-12 md:col-2" *ngIf="progressoRequisicao">
							<button type="submit" pButton icon="pi pi-spin pi-spinner" label="Salvando..."
								class="p-button-success mt-5" [disabled]="true"></button>
						</div>
						<div class="field col-12 md:col-8">

						</div>
						<div class="field col-12 md:col-2">
							<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-primary mt-5" routerLink="/rfarias/menu"></button>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>